import BaseModel from '../core/BaseModel'
export default class ViewWardModel extends BaseModel {
    constructor() {
        super({ 
                name: "view_ward",
                tableName: 'view_ward'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}